import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Router, Scroll} from '@angular/router';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {FlowTypeService} from '../../../../../shared/src/lib/services/flow-type.service';

@Component({
    selector: 'app-ai-landing',
    templateUrl: './ai-landing.component.html',
    styleUrls: ['./ai-landing.component.scss']
})
export class AiLandingComponent implements OnInit {
    testName = 'anxiety';
    uid;
    startTextButtonText = 'Start test';
    apiUrl = environment.apiUrl;

    videoSrc = 'assets/img/animation/a_brain.webm';
    anchor = null;

    constructor(
        private router: Router,
        public auth: AuthService,
        private device: DeviceDetectorService,
        private flowTypeService: FlowTypeService
    ) {
        this.router.events.subscribe((event: any) => {
            if (event instanceof Scroll && event.anchor) {
                setTimeout(() => {
                    this.anchor = event.anchor;
                }, 100);
            } else {
                this.anchor = null;

            }
        });
    }

    ngOnInit() {
        this.flowTypeService.state = 'ai';
        if (this.device.browser.toLowerCase() === 'safari') {
            this.videoSrc = null;
        }
        this.startTextButtonText = this.auth?.userState?.trial ? 'Free trial' : 'Start test';
    }

    void(event: any) {
        event.preventDefault();
    }

    async goToTest() {
        return this.router.navigate(
            ['cs'],
            {
                state: {
                    name: this.testName
                }
            });
    }

    onPaymentSuccess(prop) {
        if (prop) {
            this.goToTest().then();
        }
    }

}
